import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { getStyledSecondaryColor, getStyledPrimaryColor } from "theme/palette"
import { PRIMARY_FONT } from "theme/typography"

const TimerWrapper = styled.div`
  font-family: ${PRIMARY_FONT};
  font-size: 20px;
  color: ${getStyledPrimaryColor("timer")};
`

const getTimeParts = (duration) => {
  const minutes = Math.floor(duration / 60)
  const seconds = Math.floor(duration % 60)
  return [minutes, seconds]
}

const zeroPad2 = (number) => (number < 10 ? `0${number}` : number)

const Timer = ({ duration, ...rest }) => {
  const timeParts = getTimeParts(duration)
  return <TimerWrapper {...rest}>{`${zeroPad2(timeParts[0])}:${zeroPad2(timeParts[1])}`}</TimerWrapper>
}

Timer.propTypes = {
  duration: PropTypes.number.isRequired,
}

Timer.defaultProps = {
  duration: 0,
}

export default Timer



// WEBPACK FOOTER //
// ./src/components/atoms/Timer/index.js